import { render, staticRenderFns } from "./SeriesResults.vue?vue&type=template&id=5ac41b71&"
import script from "./SeriesResults.vue?vue&type=script&lang=js&"
export * from "./SeriesResults.vue?vue&type=script&lang=js&"
import style0 from "./SeriesResults.vue?vue&type=style&index=0&id=5ac41b71&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports